import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "card-view-container"
};
const _hoisted_2 = {
  class: "card-header"
};
const _hoisted_3 = {
  key: 0,
  class: "qualification-name"
};
const _hoisted_4 = {
  class: "qualification-edit-container"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  key: 0,
  class: "divider"
};
const _hoisted_8 = {
  key: 1,
  class: "qualification-roles-container"
};
const _hoisted_9 = {
  class: "roles-stat"
};
const _hoisted_10 = {
  key: 0,
  class: "pagination-container"
};
const _hoisted_11 = {
  class: "pagination-container"
};
import { ref, computed, onMounted, watch } from 'vue';
import { ElButton, ElInput, ElPagination, ElSwitch } from 'element-plus';
import store from '@/store';
import { request } from '@/manager/net_manager';
import { isAdminType } from '@/tools/utils';
export default {
  __name: 'QualificationCard',
  props: {
    qualification: {
      type: Object,
      required: true
    }
  },
  emits: ['update-qualification', 'update-roles', 'remove-qualification'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // refs

    const localQualification = ref(null);
    const editMode = ref(false);
    const rolesManageMode = ref(false);
    const addRolesIds = ref([]);
    const dataArray = ref([]);
    const pagerCount = ref(5);
    const size = ref(10);
    const woRolesTotal = ref(0);
    const marketPropsPage = ref(0);
    const cacheWORoles = ref({}); // computed

    const userType = computed(() => {
      return store.state.user ? parseInt(store.state.user.user_type) : 4;
    });
    const worldOutlook = computed(() => store.state.world_outlook || null);
    const addRoles = computed(() => {
      const buffer = [...Object.values(cacheWORoles.value).flat(), localQualification.value.roles];
      return buffer.filter(item => addRolesIds.value.includes(item.id));
    }); // functions

    const submitQualification = () => {
      emits('update-qualification', localQualification.value);
      editMode.value = false;
    };

    const submitQualificationRoles = () => {
      emits('update-roles', {
        'qualification_id': props.qualification.id,
        'roles': addRolesIds.value
      });
      rolesManageMode.value = false;
    };

    const removeQualification = () => {
      emits('remove-qualification', localQualification.value);
      editMode.value = false;
    };

    const getWORoles = () => {
      if (worldOutlook.value) {
        let parameters = {
          'world_outlook_id': worldOutlook.value.id,
          'qualification_id': props.qualification.id,
          'page': marketPropsPage.value,
          'size': size.value
        };
        request('qualification/get_wo_roles/', parameters, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            cacheWORoles.value[parameters.page] = response.data.roles;
            woRolesTotal.value = response.data.numbers;
            setupDataArray();
          }
        });
      }
    };

    const setupDataArray = () => {
      let buffer = [...addRoles.value, ...localQualification.value.roles]; // console.log(JSON.stringify(cacheWORoles.value))
      // console.log(JSON.stringify(marketPropsPage.value))

      if (Object.keys(cacheWORoles.value).includes(marketPropsPage.value.toString())) {
        let pageProps = cacheWORoles.value[marketPropsPage.value.toString()];
        let existsPropsIds = buffer.map(item => item.id);
        pageProps = pageProps.filter(item => !existsPropsIds.includes(item.id));
        buffer = [...buffer, ...pageProps];
      }

      dataArray.value = buffer;
    }; // const handlePropsChange = (value, direction, movedKeys) => {
    //   console.log(value, direction, movedKeys)
    // }


    const handlePageChange = index => {
      marketPropsPage.value = index - 1;

      if (!Object.keys(cacheWORoles.value).includes(marketPropsPage.value)) {
        getWORoles();
      } else {
        setupDataArray();
      }
    }; // lifecycle


    onMounted(() => {
      localQualification.value = props.qualification;
    }); // watcher

    watch(() => rolesManageMode.value, newValue => {
      if (newValue) {
        cacheWORoles.value = {};
        addRolesIds.value = localQualification.value.roles.map(item => item.id);
        handlePageChange(1);
      }
    });
    watch(() => props.qualification, newValue => {
      localQualification.value = newValue;
    });
    return (_ctx, _cache) => {
      const _component_el_row = _resolveComponent("el-row");

      const _component_el_tag = _resolveComponent("el-tag");

      const _component_el_transfer = _resolveComponent("el-transfer");

      return localQualification.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [!editMode.value ? (_openBlock(), _createElementBlock("text", _hoisted_3, _toDisplayString(localQualification.value.name && localQualification.value.name.length > 0 ? localQualification.value.name : '未命名资格'), 1)) : (_openBlock(), _createBlock(_unref(ElInput), {
        key: 1,
        modelValue: localQualification.value.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => localQualification.value.name = $event),
        maxlength: "16",
        clearable: "",
        "show-word-limit": "",
        placeholder: "资格名称"
      }, null, 8, ["modelValue"])), _createVNode(_unref(ElSwitch), {
        modelValue: editMode.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => editMode.value = $event),
        "active-text": editMode.value ? '修改' : '',
        "inactive-text": editMode.value ? '' : '预览',
        "inline-prompt": ""
      }, null, 8, ["modelValue", "active-text", "inactive-text"])]), _cache[9] || (_cache[9] = _createElementVNode("div", {
        class: "divider"
      }, null, -1)), _createElementVNode("div", _hoisted_4, [!editMode.value ? (_openBlock(), _createElementBlock("text", _hoisted_5, _toDisplayString(localQualification.value.desc && localQualification.value.desc.length > 0 ? localQualification.value.desc : '未添加描述'), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_unref(ElInput), {
        modelValue: localQualification.value.desc,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => localQualification.value.desc = $event),
        maxlength: "32",
        clearable: "",
        "show-word-limit": "",
        placeholder: "资格描述"
      }, null, 8, ["modelValue"]), _createVNode(_component_el_row, {
        style: {
          "margin-top": "1.0rem"
        }
      }, {
        default: _withCtx(() => [_withDirectives(_createVNode(_unref(ElButton), {
          class: "remove-qualification",
          onClick: removeQualification
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode(" 删除该渠道 ", -1)]))]),
          _: 1
        }, 512), [[_vShow, _unref(isAdminType)(userType.value)]]), _cache[7] || (_cache[7] = _createElementVNode("div", {
          style: {
            "flex": "1"
          }
        }, null, -1)), _createVNode(_unref(ElButton), {
          onClick: submitQualification
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" 更新资格设定 ", -1)]))]),
          _: 1
        })]),
        _: 1
      })]))]), !editMode.value ? (_openBlock(), _createElementBlock("div", _hoisted_7)) : _createCommentVNode("", true), !editMode.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_el_row, {
        class: "roles-stat-container"
      }, {
        default: _withCtx(() => [_createElementVNode("text", _hoisted_9, _toDisplayString(localQualification.value.roles?.length ?? 0) + " 位登记角色 ", 1), _createVNode(_unref(ElSwitch), {
          modelValue: rolesManageMode.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => rolesManageMode.value = $event),
          "active-text": rolesManageMode.value ? '管理' : '',
          "inactive-text": rolesManageMode.value ? '' : '预览',
          "inline-prompt": ""
        }, null, 8, ["modelValue", "active-text", "inactive-text"])]),
        _: 1
      }), !rolesManageMode.value ? (_openBlock(), _createBlock(_component_el_row, {
        key: 0
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localQualification.value.roles, item => {
          return _openBlock(), _createBlock(_component_el_tag, {
            key: item.id,
            value: item.id
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.nickname), 1)]),
            _: 2
          }, 1032, ["value"]);
        }), 128))]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_row, {
        key: 1
      }, {
        default: _withCtx(() => [_createVNode(_component_el_transfer, {
          modelValue: addRolesIds.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => addRolesIds.value = $event),
          data: dataArray.value,
          props: {
            key: 'id',
            label: 'nickname'
          },
          filterable: "",
          titles: ['世界观角色', '已授权角色']
        }, {
          "left-footer": _withCtx(() => [woRolesTotal.value > size.value ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_unref(ElPagination), {
            "page-size": size.value,
            "pager-count": pagerCount.value,
            layout: "prev, pager, next",
            total: woRolesTotal.value,
            background: true,
            onChange: handlePageChange
          }, null, 8, ["page-size", "pager-count", "total"])])) : _createCommentVNode("", true)]),
          "right-footer": _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(_unref(ElButton), {
            onClick: submitQualificationRoles
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("记录授权变更", -1)]))]),
            _: 1
          })])]),
          _: 1
        }, 8, ["modelValue", "data"])]),
        _: 1
      }))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
    };
  }

};